import { getIsApiPending, getQuoteForm, getCustomerIdValue } from '../../../selectors/ugMotorInsurance/quote';
import { getCarDetailsForm } from '../../../selectors/ugMotorInsurance/carDetails';
import { setExpiredAuth } from '../../../actions/ugMotorInsurance/quote';
import {
    apiTransitioncarDetailsForm,
    submitCarDetailsDataSuccess,
    submitCarDetailsFailure,
} from '../../../actions/ugMotorInsurance/carDetails';
import { getAccessToken } from '../../../selectors/ugMotorInsurance/payments';
import axios from 'axios';

export const checkDoubleInsuranceService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitioncarDetailsForm.pending());
            try {
                store.dispatch(submitCarDetailsDataSuccess(null));
                const resp = await checkDoubleInsurance(store.getState());
                store.dispatch(submitCarDetailsDataSuccess(resp.data));
                store.dispatch(apiTransitioncarDetailsForm.success());
            } catch (e) {
                console.error(e.response);
                if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                    store.dispatch(setExpiredAuth(true));
                }
                store.dispatch(apiTransitioncarDetailsForm.failure());
                store.dispatch(submitCarDetailsFailure(e));
            }
        }
    })();
    return next(action);
};

/*
const computePolicyEndDate = (dateString) => {
    let date = new Date(dateString);
    date.setFullYear(date.getFullYear() + 1);
    let incrementedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    return incrementedDate;
};*/

function getNextYearDate(dateString) {
    // Split the string by '/' to extract the day, month, and year
    const [day, month, year] = dateString.split('/').map(Number);

    // Increment the year by 1
    const nextYear = year + 1;

    if (month === 1) {
        // If the month is January, set it to December of the previous year
        return `${String(day).padStart(2, '0')}/12/${nextYear - 1}`;
    }

    const prevMonth = month - 1;

    // Return the new date string in the format DD/MM/YYYY
    return `${String(day).padStart(2, '0')}/${String([prevMonth]).padStart(2, '0')}/${nextYear}`;
}

const checkDoubleInsurancePayload = (state) => {
    const carDetails = getCarDetailsForm(state);
    const coverDetails = getQuoteForm(state);
    const customerId = getCustomerIdValue(state);

    const payload = {
        policystartdate: coverDetails.coverStartDate.value,
        policyenddate: coverDetails?.coverStartDate?.value ? getNextYearDate(coverDetails?.coverStartDate?.value) : '',
        vehicleregistrationnumber: carDetails.registrationNumber.value,
        chassisnumber: carDetails.chasisNumber.value,
        motorInsuranceCustomerId: customerId.value ? customerId.value.toString() : 'N/A',
    };

    // Change payload here
    return {
        ...payload,
    };
};

const checkDoubleInsurance = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ke-motor-insurance/double-insurance-check/';
        return await axios.post(url, checkDoubleInsurancePayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        /*
         if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
        store.dispatch(setExpiredAuth(true))}
        */

        console.error(e);
        throw e;
    }
};
